import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { useLocalizedPartnerDirectoryHref } from '@/libraries/web-framework/src/localization/use-localized-partnerdirectory.ts';

import { Link } from '../../../../libraries/design/components/link/src/link.tsx';

import type { LinkProps } from '../../../../libraries/design/components/link/src/link.tsx';

export const UniformLink = (props: LinkProps) => {
	let localizedHref = useLocalizedHref(props.href);

	const localizedPartnerDirectoryUrl = useLocalizedPartnerDirectoryHref(props.href);
	if (props.href !== localizedPartnerDirectoryUrl) {
		localizedHref = localizedPartnerDirectoryUrl;
	}

	return (
		<Link
			{...props}
			aria-label={props.text}
			href={localizedHref}
			dataEventProps={{
				'data-product-key': 'uniform',
				'data-event-component': 'linkButton',
				'data-event-container': 'link',
				'data-event': 'clicked',
			}}
		/>
	);
};

export default UniformLink;
